module.exports = __webpack_public_path__ + "media/images/social/facebook-square-brands-35e714b28aba936b0ee31dad44961686.svg";